import React, { Component, useEffect, useState, useContext } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import i18n from '../i18n';
import { withTranslation, Trans, withNamespaces } from 'react-i18next';

import PageLoader from './PageLoader';
import CardProduct from './CardProduct';
import BannerComponent from './BannerComponent';
import IndpCommentComponent from './IndpCommentComponent';
import {MyContext} from './AppSearchBar';
import axios from 'axios';
// import '../css/style.css';
import '../css/standalone-style.css';
import '../css/style-anniversary.css';
import '../css/style-blackfriday.css';
import '../css/style-specialoffer.css';
import '../css/style-stockclearance.css';
import '../css/style-promotion.css';

const styles = theme => ({});

const StandAlone = ({
    jwt,    
    lang,
    logged, 
    config, 
    tariff, 
    results, 
    express, 
    is_feb_page,
    fav_products, 
    cart_products, 
    selectProductId, 
    client_country_id,
    api_origin,
    api_url,
    stocks,
    customFilterManufacturerIds
}) => {

    const [ isPageLoader, setIsPageLoader ] = useState(false);
    const [ getStocks, setStocks ] = useState(stocks);

    let source = axios.CancelToken.source();

    const getStockData = async (products) => {
        if(logged){
          if (products.length > 0) {
    
             // Cancelar la solicitud anterior si existe
             if(source){
              source.cancel();
            }
            
            source = axios.CancelToken.source();
    
            let newURL = api_url+'/product-inventories?select=product_id,stock&products='+products;
            const stockProducts = await axios.get(newURL, {
              headers: { 
                "Content-type": "application/json",
                "Authorization": jwt,        
              },
              method: "GET",          
              cancelToken: source.token // Pasar el token de cancelación a la configuración de la solicitud
            }).catch(function (thrown) {
              if (axios.isCancel(thrown)) {
                console.log('Request canceled', thrown.message);
              } else {
                console.log("cancel error")
              }
             });
            
            
            if(stockProducts && stockProducts?.data && stockProducts.data?.data) {
              setStocks([...stockProducts.data.data]);
            }
          }
        }    
      }

    const  searchQuery  = useContext(MyContext);
    useEffect(() => {
        setTimeout(() => {
            setIsPageLoader(false);
        }, 4000);


        let products = results.map(obj => obj.id.raw);
        if(products.length>0) {
            getStockData(products);
        }

    }, []);

    

    return (
        <div className = "stand-alone">
            <div className = "sui-layout" id="sui-layout-div">
                {isPageLoader ? 
                    <PageLoader />
                :
                    <div className = "sui-layout-main " >
                        <div className = "sui-layout-buy" >
                            <div className = "sui-layout-main-body" >
                                <div className = 'SearchResult'
                                    style = {{ width: `100%` } } 
                                >
                                    <div >
                                        <Grid container className = "grid-row" > 
                                            {
                                                results.map((rowData, index) =>
                                                    <Grid key = { "gridProduct" + index }
                                                        item md = { 3 }
                                                        className = { `grid-col cust ${is_feb_page ? "grid-col-fev" : ""} ` } 
                                                    >

                                                        {rowData.webcode ? 
                                                            <CardProduct 
                                                                data = { rowData }
                                                                lang = { lang }
                                                                logged = { logged }
                                                                express = { express }
                                                                tariff = { tariff }
                                                                selectProductId = { selectProductId }
                                                                client_country_id = { client_country_id }
                                                                cart_products = { cart_products }
                                                                fav_products = { fav_products }
                                                                jwt = { jwt }
                                                                sa = { true }
                                                                api_origin = { api_origin }
                                                                api_url = { api_url }  
                                                                stocks = { getStocks }
                                                                customFilterManufacturerIds = { customFilterManufacturerIds }
                                                                /*stocks = {[{"product_id":parseInt(rowData.id.raw),"stock":parseInt(rowData.stock.raw)}]}*/
                                                            /> 
                                                        :
                                                            <BannerComponent
                                                                bannerData = { rowData }
                                                            />
                                                        }
                                                    </Grid>
                                                )
                                            } 
                                        </Grid> 
                                    </div> 
                                </div> 
                            </div> 
                        </div> 
                    </div> 
                }
            </div>
        </div>
        
    );
}

export default withStyles(styles)(withTranslation()(StandAlone));